import React, { useState, useEffect }  from 'react';
import { PostRequest } from 'components/common/index.js';
import SelectFlap from 'components/show_drawing/redraw_form/technical_properties/SelectFlap.jsx';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import Constants from 'components/show_drawing/Constants.jsx';
import MyEventListener from 'components/common/MyEventListener.jsx'

const TagsAsOptions = ( { id, drawing, theme, debug, workingId, setWorkingId } ) => {
  const [requestInProgress, setRequestInProgress] = useState(false);
  const key = (tag) => { return tag.flag }
  const [tags, setTags] = useState([]);
  const [values, setValues] = useState( {} );
  const [searchResult, setSearchResult] = useState( id );
  const [availableDrawings, setAvailableDrawings] = useState( [] );

  const [onFlap, setonFlap] = useState([])
  const [onTopFlap, setOnTopFlap] = useState([])
  const [onBottomFlap, setOnBottomFlap] = useState([])

  const [onDustFlap, setonDustFlap] = useState([])
  const [onTopDustFlap, setOnTopDustFlap] = useState([])
  const [onBottomDustFlap, setOnBottomDustFlap] = useState([])

  const [onTuck, setonTuck] = useState([])
  const [onTopTuck, setOnTopTuck] = useState([])
  const [onBottomTuck, setOnBottomTuck] = useState([])

  const [onGlueFlap, setOnGlueFlap] = useState([])
  const [onCover, setOnCover] = useState([])
  const [onHanger, setOnHanger] = useState([])

  const [onHangHole, setOnHangHole] = useState([])

  const [onMagazineSlots, setOnMagazineSlots] = useState([])
  const [onMagazineSlotId, setOnMagazineSlotId] = useState(id)

  const setValue = (key, value) => {
    setValues( (prev) => {
      prev[ key ] = value;
      return { ...prev }
    } )
  }

  const sortByName = (a, b) => {
    if (a.name < b.name) { return -1 }
    if (a.name > b.name) { return 1 }
    return 0;
  }

  const fetchTagsAsOptions = () => {
    // https://diecuttemplates.com.dev/tags-as-options/72606
    setRequestInProgress( () => true )
    PostRequest({
      url: `/tags-as-options/${workingId}/${window.I18nLocale}`,
      data: {},
      callback: (data) => {
        setTags( () => data.tags )

        for(let i = 0; i< data.tags.length; i++) {
          setValue(data.tags[i].flag, data.tags[i].value)
        }

        setAvailableDrawings( () => data.available_drawings )

        setonFlap( () => data.on_flap )
        setOnTopFlap( () => data.on_top_flap )
        setOnBottomFlap( () => data.on_bottom_flap )

        setonDustFlap( () => data.on_dust_flap )
        setOnTopDustFlap( () => data.on_top_dust_flap )
        setOnBottomDustFlap( () => data.on_bottom_dust_flap )

        setonTuck( () => data.on_tuck )
        setOnTopTuck( () => data.on_top_tuck )
        setOnBottomTuck( () => data.on_bottom_tuck )

        setOnGlueFlap( () => data.on_glue_flap )
        setOnCover( () => data.on_cover )
        setOnHanger( () => data.on_hanger )
        setOnHangHole( () => data.on_hang_hole )
        setOnMagazineSlots( () => (data.on_magazine_slots || []).sort(sortByName) )
        setRequestInProgress( () => false )
      }
    })
  }

  const onChange = (e) => {
    e.preventDefault();
    setValue(e.target.name, e.target.checked)
  }

  const onClick = (e, name) => {
    e.preventDefault();
    setValue(name, !values[name])
  }

  const disabled = (key) => {
    var found = false;
    var nextValues = { ...values }
    nextValues[key] = !nextValues[key]

    for(let i = 0; i < availableDrawings.length; i++) {
      var condition = true;

      for (const [key, value] of Object.entries(nextValues)) {
        condition = condition && availableDrawings[i][key] == value
      }
      if (condition) { found = true }
    }

    return !found;
  }

  const inputFor = (tag, i) => {
    var isDisabled = requestInProgress || disabled(tag.flag);
    var othersNull = onTuck == undefined && onDustFlap == undefined && onFlap == undefined
    return (
      <div key={tag.flag}>
        <span onClick={ isDisabled ? () => {} : (e) => { onClick(e, tag.flag) }}
            className={`${othersNull && i == (tags.length - 1) ? styles.last_tag : ''} ${isDisabled ? '' : styles.clickable } input-group-addon input-group-addon-${window.locale} ${styles.input_add_on_for_boolean}`}>
         <span className={`${isDisabled ? styles.disabled_label : ''}`}  >
          {t(`models.${tag.flag}`)}
          </span>

          <div className={styles.div_boolean} key={tag.flag}>
            <input
              name={tag.flag}
              key={tag.flag}
              type="checkbox"
              value="1"
              className="drawing-option-input"
              checked={values[tag.flag]}
              disabled={isDisabled}
              autoComplete="off"
              onChange={onChange}
            />
          </div>
        </span>
      </div>
    )
  }

  // useEffect starts here
  useEffect( () => {
    for(let i = 0; i < availableDrawings.length; i++) {
      var condition = true;

      for (const [key, value] of Object.entries(values)) {
        condition = condition && availableDrawings[i][key] == value
      }

      if(condition) {
        setSearchResult( () => availableDrawings[i].id )
        setWorkingId( () => availableDrawings[i].id)
        break;
      }
    }
  }, [values] )

  useEffect(fetchTagsAsOptions, [ workingId ])

  useEffect(() => {
    setWorkingId( () => onMagazineSlotId )
  }, [onMagazineSlotId])
  // useEffect ends here

  const areAllUndefined = (arr) => {
   for(let i = 0; i < arr.length; i++) { if(arr[i] != undefined && arr[i].length > 0) { return false } }
   return true;
  }

  return (
    <div key="tags-as-options" className={styles.tp_ags_as_options}>

      <div className={styles.tp_header}> <h4>  {t('models.technical_properties')} </h4> </div>

      { tags.map(inputFor) }

      {onFlap != undefined && onFlap.length > 0 && <SelectFlap
        key="flap"
        title={t('models.flap')}
        id={workingId}
        setId={setWorkingId}
        drawing={drawing}
        onFlap={onFlap}
        as="flap"
        image='flap'
        theme={theme}
        disabled={requestInProgress}
        isLast={areAllUndefined([ onTopFlap, onBottomFlap, onDustFlap, onTopDustFlap, onBottomDustFlap, onTuck, onTopTuck, onBottomTuck, onGlueFlap, onCover, onHanger ] )}
      /> }

      {onTopFlap != undefined && onTopFlap.length > 0 && <SelectFlap
        key="top_flap"
        title={t('models.top_flap')}
        id={workingId}
        setId={setWorkingId}
        drawing={drawing}
        onFlap={onTopFlap}
        as="top_flap"
        image='flap'
        theme={theme}
        disabled={requestInProgress}
        isLast={areAllUndefined([ onBottomFlap, onDustFlap, onTopDustFlap, onBottomDustFlap, onTuck, onTopTuck, onBottomTuck, onGlueFlap, onCover, onHanger ] )}
      /> }

      {onBottomFlap != undefined && onBottomFlap.length > 0 && <SelectFlap
        key="bottom_flap"
        title={t('models.bottom_flap')}
        id={workingId}
        setId={setWorkingId}
        drawing={drawing}
        onFlap={onBottomFlap}
        as="bottom_flap"
        image='flap'
        theme={theme}
        rotate={true}
        disabled={requestInProgress}
        isLast={areAllUndefined([ onDustFlap, onTopDustFlap, onBottomDustFlap, onTuck, onTopTuck, onBottomTuck, onGlueFlap, onCover, onHanger ] )}
      /> }

      {onDustFlap != undefined && onDustFlap.length > 0 && <SelectFlap
        key="dust_flap"
        title={t('models.dust_flap')}
        id={workingId}
        setId={setWorkingId}
        drawing={drawing}
        onFlap={onDustFlap}
        as="dust_flap"
        image='dust_flap'
        theme={theme}
        disabled={requestInProgress}
        isLast={areAllUndefined([ onTopDustFlap, onBottomDustFlap, onTuck, onTopTuck, onBottomTuck, onGlueFlap, onCover, onHanger ] )}
      /> }


      {onTopDustFlap != undefined && onTopDustFlap.length > 0 && <SelectFlap
        key="top_dust_flap"
        title={t('models.top_dust_flap')}
        id={workingId}
        setId={setWorkingId}
        drawing={drawing}
        onFlap={onTopDustFlap}
        as="top_dust_flap"
        image='dust_flap'
        theme={theme}
        disabled={requestInProgress}
        isLast={areAllUndefined([ onBottomDustFlap, onTuck, onTopTuck, onBottomTuck, onGlueFlap, onCover, onHanger ] )}
      /> }

      {onBottomDustFlap != undefined && onBottomDustFlap.length > 0 && <SelectFlap
        key="bottom_dust_flap"
        title={t('models.bottom_dust_flap')}
        id={workingId}
        setId={setWorkingId}
        drawing={drawing}
        onFlap={onBottomDustFlap}
        as="bottom_dust_flap"
        image='dust_flap'
        theme={theme}
        rotate={true}
        disabled={requestInProgress}
        isLast={areAllUndefined([ onTuck, onTopTuck, onBottomTuck, onGlueFlap, onCover, onHanger ] )}
      /> }

      {onTuck != undefined && onTuck.length > 0 && <SelectFlap
        key="tuck"
        title={t('models.tuck')}
        id={workingId}
        setId={setWorkingId}
        drawing={drawing}
        onFlap={onTuck}
        as="tuck"
        image='tuck'
        theme={theme}
        disabled={requestInProgress}
        isLast={areAllUndefined([ onTopTuck, onBottomTuck, onGlueFlap, onCover, onHanger ] )}
      /> }

      {onTopTuck != undefined && onTopTuck.length > 0 && <SelectFlap
        key="top_tuck"
        title={t('models.top_tuck')}
        id={workingId}
        setId={setWorkingId}
        drawing={drawing}
        onFlap={onTopTuck}
        as="top_tuck"
        image='tuck'
        theme={theme}
        disabled={requestInProgress}
        isLast={areAllUndefined([ onBottomTuck, onGlueFlap, onCover, onHanger ] )}
      /> }

      {onBottomTuck != undefined && onBottomTuck.length > 0 && <SelectFlap
        key="bottom_tuck"
        title={t('models.bottom_tuck')}
        id={workingId}
        setId={setWorkingId}
        drawing={drawing}
        onFlap={onBottomTuck}
        as="bottom_tuck"
        image='tuck'
        theme={theme}
        rotate={true}
        disabled={requestInProgress}
        isLast={areAllUndefined([ onGlueFlap, onCover, onHanger ] )}
      /> }


      {onGlueFlap != undefined && onGlueFlap.length > 0 && <SelectFlap
        key="glue_flap"
        title={t('models.glue_flap')}
        id={workingId}
        setId={setWorkingId}
        drawing={drawing}
        onFlap={onGlueFlap}
        as="glue_flap"
        image='glue_flap'
        theme={theme}
        disabled={requestInProgress}
        isLast={areAllUndefined([ onCover, onHanger ] )}
      /> }

      {onCover != undefined && onCover.length > 0 && <SelectFlap
        key="cover"
        title={t('models.cover')}
        id={workingId}
        setId={setWorkingId}
        drawing={drawing}
        onFlap={onCover}
        as="cover"
        image='cover'
        theme={theme}
        disabled={requestInProgress}
        isLast={areAllUndefined([ onHanger ] )}
      /> }

      {onHanger != undefined && onHanger.length > 0 && <SelectFlap
        key="hanger"
        title={t('models.hanger')}
        id={workingId}
        setId={setWorkingId}
        drawing={drawing}
        onFlap={onHanger}
        as="hanger"
        image='hanger'
        theme={theme}
        disabled={requestInProgress}
         isLast={areAllUndefined([ onCover ] )}
      /> }

      {onHangHole != undefined && onHangHole.length > 0 && <SelectFlap
        key="hang_hole"
        title={t('models.hang_hole')}
        id={workingId}
        setId={setWorkingId}
        drawing={drawing}
        onFlap={onHangHole}
        as="hang_hole"
        image='hang_hole'
        theme={theme}
        disabled={requestInProgress}
        isLast={true}
      /> }

      {onMagazineSlots != undefined && onMagazineSlots.length > 0 && drawing.magazine_slot != undefined && (
        <div className={styles.container} key="onMagazineSlots" style={{marginBottom: '10px'}}>
          <label className={styles.label}> { t('models.type') } </label>

          <select value={onMagazineSlotId} onChange={(e) => setOnMagazineSlotId( () => e.target.value) }
            className="form-control" >
            {onMagazineSlots.map((onMagazineSlot) => {
              return <option value={onMagazineSlot.drawing_id}> {onMagazineSlot.name} </option>
            }) }
          </select>
        </div>
      )}

      <br />

    </div>
  )
}

export default TagsAsOptions;
